<template>
  <v-container fluid>
    <v-row class="mt-n7" no-gutters justify="center">
      <span style="font-size: 34px; color: #616161"
        ><v-icon large class="pr-1 pb-2">repeat</v-icon>Creacion de combos</span
      >
    </v-row>
    <v-layout align-start>
      <v-flex>
        <HeaderFilters
          v-if="page == 1"
          class="pt-2"
          @refreshWarehouse="get_transformations"
          :filter_default="defaultFilters"
          :show_all_option="true"
          :show_date_start="true"
        />
        <v-row justify="center" v-if="page == 2" class="pb-3">
          <span style="font-size: 24px; color: #616161"
            >Detalles de la transformacion</span
          >
        </v-row>
        <v-card flat>
          <v-card-text>
            <v-stepper flat non-linear v-model="page">
              <v-stepper-content step="1" class="pa-0">
                <v-card outlined class="mt-2 pt-2">
                  <v-card-text class="pa-0">
                    <v-data-table
                      :headers="headerArticle"
                      :search="search"
                      :items="combo_transformations"
                      item-key="id"
                      :items-per-page="10"
                      :footer-props="{
                        itemsPerPageOptions: [10, 20, 30, 40, 50],
                      }"
                    >
                      <template v-slot:top>
                        <v-toolbar flat>
                          <v-toolbar-title>Transformaciones</v-toolbar-title>
                          <v-divider class="mx-4" inset vertical></v-divider>
                          <span>{{ combo_transformations.length }}</span>
                          <v-spacer></v-spacer>
                          <v-text-field
                            class="text-xs-center"
                            v-model="search"
                            append-icon="search"
                            label="Buscar"
                            single-line
                            hide-details
                            outlined
                            dense
                          >
                          </v-text-field>
                          <v-spacer></v-spacer>
                          <v-divider class="mx-3" inset vertical></v-divider>
                          <v-btn
                            v-if="hasFeature('INV-16')"
                            color="success"
                            class="mr-2"
                            outlined
                            @click="get_combos()"
                          >
                            Nuevo
                            <v-icon>add</v-icon>
                          </v-btn>
                        </v-toolbar>
                      </template>
                      <template v-slot:[`item.show`]="{ item }">
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-bind="attrs"
                              v-on="on"
                              color="primary"
                              @click="view_detail(item, 1)"
                              large
                            >
                              read_more
                            </v-icon>
                          </template>
                          <span>Ver detalle</span>
                        </v-tooltip>
                      </template>
                    </v-data-table>
                    <!-- <v-card>
                      <v-row justify="end" align="center">
                        <v-col cols="12" md="1">
                          <span
                            class="font-weight-bold"
                            style="color: #607d8b; font-size: 15px"
                          >
                            TOTAL
                          </span>
                        </v-col>
                        <v-col md="2" align="center">
                          <th
                            style="font-size: 20px"
                            class="font-weight-bold text-right success--text"
                          >
                            {{
                              currencyFormat(0)
                            }}
                            USD
                          </th>
                        </v-col>
                      </v-row>
                    </v-card> -->
                  </v-card-text>
                </v-card>
              </v-stepper-content>
              <v-stepper-content step="2" class="pa-0">
                <v-container fluid>
                  <v-row class="mb-2" justify="space-between" v-if="is_new">
                    <v-col md="4">
                      <v-autocomplete
                        v-model="new_transformation_combo.item_to"
                        :items="all_combos"
                        item-text="item_name"
                        item-value="item_id"
                        label="Combo a convertir"
                        return-object
                        dense
                        hide-details
                        outlined
                      ></v-autocomplete>
                    </v-col>
                    <v-col md="4" align="center" justify="center">
                      <label
                        v-show="new_transformation_combo.item_to != null"
                        for="available"
                        >Existencia actual:
                        {{
                          new_transformation_combo.item_to?.item_in_warehouses[0]
                            ?.quantity
                        }}</label
                      >
                    </v-col>
                    <v-col md="4">
                      <v-text-field
                        v-model="new_transformation_combo.quantity"
                        :label="`${
                          new_transformation_combo.quantity < 0
                            ? `Maximo a deshacer(${new_transformation_combo.item_to?.item_in_warehouses[0]?.quantity})`
                            : `Maximo a crear: (${max_available_combo})`
                        }`"
                        dense
                        hide-details
                        :max="max_available_combo"
                        :min="
                          new_transformation_combo.item_to?.item_in_warehouses[0]
                            ?.quantity * -1
                        "
                        outlined
                        type="number"
                        :rules="[
                          (v) => v <= max_available_combo || 'Excede la cantidad maxima!',
                        ]"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="!is_new" class="mb-2">
                    <v-col md="3" align="center">
                      <v-text-field
                        v-model="new_transformation_combo.item_to.created_date"
                        outlined
                        label="Fecha"
                        dense
                        readonly
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col md="4" align="center">
                      <v-text-field
                        v-model="new_transformation_combo.item_to.item"
                        outlined
                        label="Combo"
                        dense
                        readonly
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col md="2" align="center">
                      <v-text-field
                        v-model="new_transformation_combo.item_to.quantity"
                        outlined
                        label="Cantidad"
                        dense
                        readonly
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col md="3" align="center">
                      <v-text-field
                        v-model="new_transformation_combo.item_to.use_fullname"
                        outlined
                        label="Realizado por"
                        dense
                        readonly
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-card outlined>
                    <v-card-title>{{
                      new_transformation_combo.item_to == null
                        ? "Escoja un item"
                        : "Items que componen el combo:"
                    }}</v-card-title>
                    <v-card-text>
                      <v-simple-table height="35vh">
                        <template v-slot:default>
                          <thead>
                            <tr style="background-color: #f9fafd">
                              <th class="text-left">ID</th>
                              <th class="text-left">Item</th>
                              <th class="text-left">Cantidad</th>
                              <th class="text-left" v-if="is_new">Disponible</th>
                              <th class="text-left" v-if="is_new">Diferencia</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="item in new_transformation_combo?.item_to
                                ?.item_in_recipes"
                              :key="item.item_id"
                            >
                              <td>
                                {{ item.item_id }}
                              </td>
                              <td>
                                {{ item.item_name }}
                              </td>
                              <td>
                                {{ item.quantity }}
                              </td>
                              <td v-if="is_new">
                                {{ item.available }}
                              </td>
                              <td v-if="is_new">
                                {{
                                  item.quantity * new_transformation_combo.quantity * -1 >
                                  0
                                    ? "+"
                                    : ""
                                }}{{
                                  item.quantity * new_transformation_combo.quantity * -1
                                }}
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        v-if="is_new"
                        text
                        color="success"
                        :disabled="
                          new_transformation_combo.quantity > max_available_combo ||
                          new_transformation_combo.item_to == null ||
                          new_transformation_combo.quantity == 0
                        "
                        @click="create_or_remove_combo()"
                        :loading="loading_save"
                        >Procesar</v-btn
                      >
                      <v-btn
                        @click="page = 1"
                        color="error"
                        text
                        v-show="$route.query.id == undefined"
                        >{{ is_new ? "Cancelar" : "Volver" }}</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-container>
              </v-stepper-content>
            </v-stepper>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog
      v-if="$store.state.app.filters.location != null"
      width="auto"
      v-model="dialogItems"
    >
      <articles_catalogue
        v-if="refresArticles"
        @selected-item="addItem"
        :removeItemSelected="false"
        :data="{
          location: $store.state.app.filters.location.value,
          business: $store.state.app.filters.business,
          warehouse: filters.warehouse.id,
          catalogue: filters.location.catalogue_id,
        }"
        @close-item="dialogItems = false"
      />
    </v-dialog>
  </v-container>
</template>
<script>
import moment from "moment";
import HeaderFilters from "@/components/Inventory/HeaderFilters.vue";
import articles_catalogue from "@/components/Inventory/CatalogeForAdjustment.vue";
import NavigationButonsTop from "@/components/Inventory/NavigationButonsTop.vue";
export default {
  data: () => ({
    is_new: false,
    loading_save: false,
    page: 1,
    filters: null,
    reason_to_filter: null,
    refresArticles: false,
    dialogItems: false,
    all_combos: [],
    combo_transformations: [],
    search: "",
    new_transformation_combo: {
      item_to: {
        created_date: null,
        quantity: null,
        item: null,
        use_fullname: null,
      },
      quantity: 1,
      item_in_warehouses: [],
    },
    headerArticle: [
      {
        text: "ID",
        align: "start",
        value: "id",
      },
      { text: "Fecha", value: "date_formated" },
      { text: "Item", value: "item" },
      { text: "Item id", value: "parent_item_id" },
      { text: "Cantidad", value: "quantity" },
      { text: "Realizado por", value: "use_fullname" },
      { text: "", value: "show", sortable: false },
    ],
    defaultFilters: [],
  }),
  components: {
    articles_catalogue,
    HeaderFilters,
    NavigationButonsTop,
  },
  mounted() {
    if (this.$route.query.id != undefined) {
      this.view_detail({ id: this.$route.query.id }, 2);
    }
  },
  computed: {
    reasons_to_filter() {
      return [];
    },
    max_available_combo() {
      if (this.new_transformation_combo.item_to == null) {
        return 0;
      }
      // Para cada item, calculamos cuántos combos se pueden hacer con su cantidad disponible
      // Math.floor asegura que redondeamos hacia abajo
      const posiblesCombos = this.new_transformation_combo?.item_to?.item_in_recipes.map(
        (item) => {
          return Math.floor(item.available / item.quantity);
        }
      );

      // El número máximo de combos posibles será el menor de los resultados
      return Math.min(...posiblesCombos);
    },
  },
  methods: {
    async get_combos() {
      if (this.filters.warehouse.id == null || this.filters.warehouse.id == 0) {
        this.$toast.warning("Seleccione un almacen");
        return;
      }
      this.new_transformation_combo.item_to = {
        created_date: null,
        quantity: null,
        item: null,
        use_fullname: null,
        item_in_recipes: [],
      };
      this.new_transformation_combo.quantity = 1;
      this.is_new = true;
      this.page = 2;

      try {
        this.new_transformation_combo.item_to = null;
        const request = await this.api_Post("inventory/combos_to_transformation", {
          business_unit_id: this.$store.state.app.filters.business,
          location_id: this.$store.state.app.filters.location.value,
          warehouse_id: this.filters.warehouse.id,
        });
        const data = await request.json();

        if (request.status == 200) {
          this.all_combos = data;
        }
      } catch (error) {
        console.error(error.message);
      }
    },
    async get_transformations(filters) {
      if (filters != null) {
        this.filters = filters;
      }
      if (this.filters.warehouse.id == null || this.filters.warehouse.id == 0) {
        this.$toast.warning("Seleccione un almacen");
        return;
      }
      try {
        const request = await this.api_Post(
          "inventory/get_combo_transformation_history",
          {
            date_start: this.filters.dateStart,
            date_end: this.filters.dateEnd,
            business_unit_id: this.$store.state.app.filters.business,
            location_id: this.$store.state.app.filters.location.value,
            warehouse_id: this.filters.warehouse.id,
          }
        );
        const data = await request.json();
        this.combo_transformations = data;
        for (let key in this.combo_transformations) {
          this.combo_transformations[key].date_formated = moment(
            this.combo_transformations[key].created_date
          ).format("DD/MM/YYYY HH:mm:ss");
        }
      } catch (error) {
        console.error(error.message);
      }
    },
    async create_or_remove_combo() {
      if (
        this.new_transformation_combo.quantity < 0 &&
        Math.abs(this.new_transformation_combo.quantity) >
          this.new_transformation_combo.item_to?.item_in_warehouses[0]?.quantity
      ) {
        this.$toast.warning(
          "No puede deshacer mas combos de lo que tiene disponible en el almacen"
        );
        return;
      }
      if (
        this.new_transformation_combo.quantity > 0 &&
        this.new_transformation_combo.quantity > this.max_available_combo
      ) {
        this.$toast.warning(
          "No hay suficientes items para crear esta cantidad de combos"
        );
        return;
      }
      try {
        this.loading_save = true;
        const request = await this.api_Post("inventory/create_or_remove_combo", {
          location_id: this.$store.state.app.filters.location.value,
          warehouse_id: this.filters.warehouse.id,
          item_id: this.new_transformation_combo.item_to.item_id,
          quantity: Math.abs(this.new_transformation_combo.quantity),
          user_id: this.$store.state.auth.user.user.user_id,
          is_remove: this.new_transformation_combo.quantity < 0,
        });
        if (request.status == 200) {
          this.$toast.success("Transformacion exitosa!");
          await this.get_transformations(null);
          this.page = 1;
        }
      } catch (error) {
        console.error(error.message);
        this.loading_save = false;
      }
      this.loading_save = false;
    },
    async view_detail(combo, type) {
      this.is_new = false;
      try {
        const request = await this.api_Get(
          "inventory/combos_to_transformation_details/" + combo.id
        );
        if (request.status == 200) {
          const data = await request.json();
          this.new_transformation_combo.item_to = {
            item: combo.item,
            quantity: `${combo.quantity > 0 ? "+" : ""}${combo.quantity}`,
            created_date: moment(combo.created_date).format("DD/MM/YYYY HH:mm:ss"),
            use_fullname: combo.use_fullname,
            item_in_recipes: data,
          };
          this.page = 2;
          if (type == 2) {
            const request = await this.api_Post(
              "inventory/get_combo_transformation_history",
              {
                id: combo.id,
              }
            );
            const data = await request.json();
            this.new_transformation_combo.item_to.use_fullname = data[0].use_fullname;
            this.new_transformation_combo.item_to.item = data[0].item;
            this.new_transformation_combo.item_to.created_date = moment(
              data[0].created_date
            ).format("DD/MM/YYYY HH:mm:ss");
            this.new_transformation_combo.item_to.quantity = data[0].quantity;
          }
        }
      } catch (error) {
        console.error(error.message);
      }
      this.loading_save = false;
    },
  },
};
</script>
